/*------------
Version: 1.3
------------*/
import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
  CircularProgress,
  IconButton as MuiIconButton,
} from "@material-ui/core";
import Tooltip from "../Tooltip";

const useStyles = makeStyles((theme) => ({
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function IconButton({
  className,
  disabled,
  icon,
  onClick,
  showLoading,
  size,
  tooltip,
  ...rest
}) {
  const classes = useStyles();
  const buttonClassName = clsx(className, "jarvisButton");

  let buttonProps = { size: size };

  if (tooltip && !showLoading && !disabled)
    return (
      <Tooltip label={tooltip}>
        <MuiIconButton
          className={buttonClassName}
          disabled={showLoading}
          onClick={onClick}
          {...buttonProps}
          {...rest}
        >
          {icon}
          {showLoading && (
            <CircularProgress className={classes.buttonProgress} size={24} />
          )}
        </MuiIconButton>
      </Tooltip>
    );

  return (
    <MuiIconButton
      className={buttonClassName}
      disabled={showLoading}
      onClick={onClick}
      {...buttonProps}
      {...rest}
    >
      {icon}
      {showLoading && (
        <CircularProgress className={classes.buttonProgress} size={24} />
      )}
    </MuiIconButton>
  );
}

IconButton.propTypes = {
  fontSize: PropTypes.number,
  showLoading: PropTypes.bool,
  size: PropTypes.oneOf(["large", "medium", "small"]),
  tooltip: PropTypes.string,
};

IconButton.defaultProps = {
  size: "small",
};
